import { put, takeLatest, call, all, select } from "redux-saga/effects";
import profileApi from "api/profile";
import { actions } from "../actions";

// Worker Sagas
function* fetchUserDetailsSaga(action) {
  try {
    if (!action.userId) return;

    const userData = yield call(
      profileApi.getUserProfileByIdApi,
      action.userId
    );
    yield put(actions.setUserDetails(userData));
  } catch (error) {
    console.error("Error fetching user details:", error);
    yield put(actions.setUserDetails({}));
  }
}

function* fetchUserDomainsSaga(action) {
  try {
    if (!action.userId) return;

    const domains = yield call(profileApi.getUserDomainsByIdApi, action.userId);

    yield put(actions.setUserDomains(domains));
  } catch (error) {
    console.error("Error fetching user domains:", error);
    yield put(actions.setUserDomains([]));
  }
}

function* fetchUserSubDomainsSaga(action) {
  try {
    if (!action.userId) return;

    const subDomains = yield call(
      profileApi.getUserSubDomainsByIdApi,
      action.userId
    );
    yield put(actions.setUserSubDomains(subDomains));
  } catch (error) {
    console.error("Error fetching user sub domains:", error);
    yield put(actions.setUserSubDomains([]));
  }
}

function* uploadUserLogoSaga({ file, cb }) {
  try {
    const formData = new FormData();
    formData.append("logo", file);

    yield call(profileApi.uploadUserLogoApi, formData);

    // Refresh user details from server
    const userId = yield select((state) => state.user?.id);
    if (userId) {
      yield put(actions.fetchUserDetails(userId));
    }

    cb?.(true);
  } catch (error) {
    console.error("Error uploading user logo:", error);
    cb?.(false, error);
  }
}

function* deleteUserLogoSaga({ cb }) {
  try {
    yield call(profileApi.deleteUserLogoApi);

    // Refresh user details from server
    const userId = yield select((state) => state.user?.id);
    if (userId) {
      yield put(actions.fetchUserDetails(userId));
    }

    cb?.(true);
  } catch (error) {
    console.error("Error deleting user logo:", error);
    cb?.(false, error);
  }
}

// Watcher Saga
function* updateVendorExperienceSaga({ vendorId, payload, cb }) {
  try {
    yield call(profileApi.updateVendorExperienceApi, vendorId, payload);

    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

export function* userSaga() {
  yield all([
    takeLatest(actions.VM_FETCH_USER_DETAILS, fetchUserDetailsSaga),
    takeLatest(actions.VM_FETCH_USER_DOMAINS, fetchUserDomainsSaga),
    takeLatest(actions.VM_FETCH_USER_SUB_DOMAINS, fetchUserSubDomainsSaga),
    takeLatest(actions.VM_UPLOAD_USER_LOGO, uploadUserLogoSaga),
    takeLatest(actions.VM_DELETE_USER_LOGO, deleteUserLogoSaga),
    takeLatest(actions.VM_UPDATE_VENDOR_EXPERIENCE, updateVendorExperienceSaga),
  ]);
}
